(function($) {
	$(document).ready(function(){

		$('.viewby--two').on('click', function(){
			$('ul.products').addClass('row-of-2');
			$('ul.products').removeClass('row-of-3 row-of-4');
			$(this).addClass('active');
			$('.viewby--three').removeClass('active');
			$('.viewby--four').removeClass('active');
		});

		$('.viewby--three').on('click', function(){
			$('ul.products').addClass('row-of-3');
			$('ul.products').removeClass('row-of-2 row-of-4');
			$(this).addClass('active');
			$('.viewby--two').removeClass('active');
			$('.viewby--four').removeClass('active');
		});

		$('.viewby--four').on('click', function(){
			$('ul.products').addClass('row-of-4');
			$('ul.products').removeClass('row-of-2 row-of-3');
			$(this).addClass('active');
			$('.viewby--two').removeClass('active');
			$('.viewby--three').removeClass('active');
		});

	});
})(jQuery); // Fully reference jQuery after this point.